<div [formGroup]="form">
    <mat-form-field>
        <mat-label>{{ field.label }}</mat-label>

        <ng-container [ngSwitch]="field.type">
            <ng-container *ngSwitchCase="'text'">
                <input type="text" matInput [id]="field.key" [formControlName]="field.key" />
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
                <input
                    type="number"
                    matInput
                    OnlyNumber
                    [id]="field.key"
                    [formControlName]="field.key"
                    [appRoundInputValue]="field.decimalPositions"
                />
            </ng-container>

            <ng-container *ngSwitchCase="'select'">
                <mat-select [id]="field.key" [formControlName]="field.key">
                    <ng-container *ngIf="field.options as options">
                        <mat-option *ngFor="let option of options" [value]="option">{{
                            option.label
                        }}</mat-option>
                    </ng-container>
                </mat-select>
            </ng-container>

            <ng-container *ngSwitchCase="'select-tree'">
                <mat-select [id]="field.key" [formControlName]="field.key">
                    <mat-select-trigger>
                        {{ form.controls[field.key].value.description }}
                    </mat-select-trigger>
                    <ng-container *ngIf="field.options as options">
                        <app-tree-view [data]="field.options" [nodeTemplateRef]="nodeTemplate">
                        </app-tree-view>

                        <ng-template #nodeTemplate let-node="data">
                            <mat-option class="tree-item" [value]="node.item">
                                <mat-icon *ngIf="node.item.icon" class="icon">{{
                                    node.item.icon
                                }}</mat-icon>
                                <span>{{ node.item.label }}</span>
                            </mat-option>
                        </ng-template>
                    </ng-container>
                </mat-select>
            </ng-container>
        </ng-container>

        <span *ngIf="field.suffix" matTextSuffix>{{ field.suffix }}</span>
        <mat-icon *ngIf="field.tooltip" matSuffix [matTooltip]="field.tooltip">help</mat-icon>
        <mat-error *ngIf="!isValid">{{ errorMessage }}</mat-error>
    </mat-form-field>
</div>
